var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.0069C18.0022 12.7442 17.9012 12.4912 17.7187 12.3023L12.7085 7.29331C12.5205 7.1055 12.2657 7 12 7C11.7343 7 11.4795 7.1055 11.2915 7.29331L6.28129 12.3023C6.09876 12.4912 5.99775 12.7442 6.00004 13.0069C6.00232 13.2696 6.10771 13.5208 6.2935 13.7066C6.47928 13.8923 6.73061 13.9977 6.99335 14C7.25608 14.0022 7.5092 13.9013 7.69819 13.7188L12 9.41811L13.0021 10.4199L16.3018 13.7188C16.4908 13.9013 16.7439 14.0022 17.0067 14C17.2694 13.9977 17.5207 13.8923 17.7065 13.7066C17.8923 13.5208 17.9977 13.2696 18 13.0069Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpSm);
export default __webpack_public_path__ + "static/media/up-sm.c6c2cead10c30082f61b479e0a3b4594.svg";
export { ForwardRef as ReactComponent };